import React from 'react';
import { Box, Flex, Button } from '@chakra-ui/react';
import Logo from './logo';

export default function Header() {
  return (
    <Box
      as="header"
      role="banner"
      px={{ base: "20px", md: "30px" }}
      h="88px"
      display="flex"
      alignItems="center"
      position="sticky"
      top={0}
      zIndex={1000}
      bg="rgba(249, 249, 249, 0.85)"
      backdropFilter="blur(12px)"
      WebkitBackdropFilter="blur(12px)"
    >
      <Flex as="nav" aria-label="Navigation principale" justify="space-between" align="center" mx="auto" w="100%">
        {/* Logo */}
        <Logo size={40} />

        {/* CTA Button */}
        <Button
          as="a"
          href="https://discord.gg/qJhmqbmcb2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Rejoins le Discord
        </Button>
      </Flex>
    </Box>
  );
}
